import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';

import { MyApp } from './app.component';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SplitPaneProvider } from '../providers/split-pane/split-pane';
import { RequestServiceProvider } from '../providers/request-service/request-service';
import {Contacts} from '@ionic-native/contacts';
import { AuthProvider } from '../providers/auth/auth';
import { HttpClientModule } from '@angular/common/http';
import { EncryptionProvider } from '../providers/encryption/encryption';
import { LoadingProvider } from '../providers/loading/loading';
import { TransactionAlertProvider } from '../providers/transaction-alert/transaction-alert';
import { Camera } from '@ionic-native/camera';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { ProfileCropPage } from '../pages/profile-crop/profile-crop';
import { ProfilePageModule } from '../pages/profile/profile.module';
import { AgentPageModule } from '../pages/agent/agent.module';
import { ChangePasswordPageModule } from '../pages/change-password/change-password.module';
import { EnquiriesPageModule } from '../pages/enquiries/enquiries.module';
import { ForgetPasswordPageModule } from '../pages/forget-password/forget-password.module';
import { RegistrationCompletePageModule } from '../pages/registration-complete/registration-complete.module';
import { LoginPageModule } from '../pages/login/login.module';
import { ProfileCropPageModule } from '../pages/profile-crop/profile-crop.module';
import { RegisterPageModule } from '../pages/register/register.module';
import { SettingsPageModule } from '../pages/settings/settings.module';
import { TabsPageModule } from '../pages/tabs/tabs.module';
import { TransactionsPageModule } from '../pages/transactions/transactions.module';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { SocialSharing } from '@ionic-native/social-sharing';
import { OpenAccountPageModule } from '../pages/open-account/open-account.module';
import { BanksPageModule } from '../pages/banks/banks.module';
import { EventsPageModule } from '../pages/events/events.module';
import {EventDetailsPageModule} from "../pages/event-details/event-details.module";
import { HomePageModule } from '../pages/home/home.module';
import {SelectBankTypePageModule} from "../pages/select-bank-type/select-bank-type.module";
import {BankSelectorPageModule} from "../pages/bank-selector/bank-selector.module";
import {WithdrawMoneySelectorPageModule} from "../pages/withdraw-money-selector/withdraw-money-selector.module";
import { ExternalCashoutPageModule } from '../pages/external-cashout/external-cashout.module';
import {ProfileNewPageModule} from "../pages/profile-new/profile-new.module";
import { ChangePinPageModule } from '../pages/change-pin/change-pin.module';
import {MicroInsurancePageModule} from "../pages/micro-insurance/micro-insurance.module";
import {InsuranceSelectorPageModule} from "../pages/insurance-selector/insurance-selector.module";
import {BuyInsurancePageModule} from "../pages/buy-insurance/buy-insurance.module";
import {CashPickupPageModule} from "../pages/cash-pickup/cash-pickup.module";
import { Geolocation } from '@ionic-native/geolocation';
import { MapsProvider } from '../providers/maps/maps';
import {BluetoothSerial} from "@ionic-native/bluetooth-serial";
import { BluetoothProvider } from '../providers/bluetooth/bluetooth';
import { ToastProvider } from '../providers/toast/toast';
import {BluetoothPrinterPageModule} from "../pages/bluetooth-printer/bluetooth-printer.module";
import {PrinterListPage} from "../pages/printer-list/printer-list";
import { PrinterServiceProvider } from '../providers/printer-service/printer-service';
import {PendingTransactionPageModule} from "../pages/pending-transaction/pending-transaction.module";
import {CardTransactionsPageModule} from "../pages/card-transactions/card-transactions.module";
import { PinPadProvider } from '../providers/pin-pad/pin-pad';
import { MposProvider } from '../providers/mpos/mpos';
import { GlobalProvider } from '../providers/global/global';
import { ScannerProvider } from '../providers/scanner/scanner';
import { UssdTransactionsPageModule } from '../pages/ussd-transactions/ussd-transactions.module';




@NgModule({
  declarations: [
    MyApp,
    ProfileCropPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    HttpModule,
    HttpClientModule,
    AngularCropperjsModule,
    ProfilePageModule,
    AgentPageModule,
    HomePageModule,
    ChangePasswordPageModule,
    EnquiriesPageModule,
    ForgetPasswordPageModule,
    RegistrationCompletePageModule,
    LoginPageModule,
    ProfileCropPageModule,
    RegisterPageModule,
    SettingsPageModule,
    TabsPageModule,
    TransactionsPageModule,
    OpenAccountPageModule,
    BanksPageModule,
    EventsPageModule,
    EventDetailsPageModule,
    SelectBankTypePageModule,
    BankSelectorPageModule,
    WithdrawMoneySelectorPageModule,
    ExternalCashoutPageModule,
    ProfileNewPageModule,
    ChangePinPageModule,
    MicroInsurancePageModule,
    InsuranceSelectorPageModule,
    BuyInsurancePageModule,
    CashPickupPageModule,
    BluetoothPrinterPageModule,
    PendingTransactionPageModule,
    CardTransactionsPageModule,
    UssdTransactionsPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    // HomePage,
    // EnquiriesPage,
    // TransactionsPage,
    // RegisterPage,
    // LoginPage,
    // TabsPage,
    // AgentPage,
    // ForgetPasswordPage,
    // RegistrationCompletePage,
    // SettingsPage,
    // ChangePasswordPage,
    // ProfileCropPage,
    // ProfilePage,
    // OpenAccountPage,
    // BanksPage,
    // EventsPage

  ],
  providers: [
    StatusBar,
    SplashScreen,
    SplitPaneProvider,RequestServiceProvider,AuthProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Contacts,
    Camera,
    EncryptionProvider,
    LoadingProvider,
    TransactionAlertProvider,
    File,
    FileOpener,
    SocialSharing,
    Geolocation,
    MapsProvider,
    BluetoothSerial,
    BluetoothProvider,
    ToastProvider,
    PrinterServiceProvider,
    PinPadProvider,
    MposProvider,
    GlobalProvider,
    ScannerProvider

  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts